/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { assets } from '../../../core/constants/assets.const';
import { MatInputModule } from '@angular/material/input';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { CountryCodeConst } from '../../../core/constants/countryCode.const';
import { countryCode } from '../../../models/countryCode.model';
import { ImageUploadService } from '../../../services/uploadImage.service';
import { take } from 'rxjs';
import { addressChange } from '../../../core/helpers/addressChange.helper';
import { CommonModule } from '@angular/common';
import { nameValidator } from '../../../core/helpers/validators.helper';
import { REGEX } from '../../../core/constants/regex.const';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GooglePlacesService } from '../../../services/google-place.service';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'xplora-website-member-step1',
  standalone: true,
  templateUrl: './member-step1.component.html',
  styleUrl: './member-step1.component.scss',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    RouterModule,
    ReactiveFormsModule,
    NgxMatIntlTelInputComponent
  ]
})
export class MemberStep1Component implements OnInit {
  countryCodeObject: countryCode = CountryCodeConst;
  assetsConst = assets;
  submitted: boolean = false;
  memberFormGroup: FormGroup;

  constructor(
    private _googlePlaces: GooglePlacesService,
    private formBuilder: FormBuilder,
    private _uploadImageService: ImageUploadService,
    private MatDialogRef: MatDialogRef<MemberStep1Component>
  ) {
    this.memberFormGroup = this.formBuilder.group({
      image: [''],
      businessName: [
        '',
        [nameValidator(), Validators.pattern(REGEX.STRING_ONLY)]
      ],
      name: ['', [nameValidator(), Validators.pattern(REGEX.STRING_ONLY)]],
      address: ['', Validators.required],
      city: ['', Validators.required],
      pinCode: ['', [Validators.maxLength(10)]],
      email: ['', [Validators.required, Validators.pattern(REGEX.Email)]],
      phoneNo: ['', Validators.required],
      dialCode: [''],
      companyWebsite: [''],
      typeOfBusiness: ['', Validators.required],
      latitude: new FormControl(),
      longitude: new FormControl()
    });

  }

  ngOnInit(): void {
    this.memberFormGroup.get('address')?.valueChanges.subscribe((value) => {
      if (!value) {
        this.memberFormGroup.patchValue({
          city: '',
          pinCode: ''
        });
      }
    });
  }

  close(): void {
    this.MatDialogRef.close(false);
  }

  onFileChange(event: Event): void {
    this._uploadImageService
      .onFileChange(event)
      .then((res: { data: { image: string } }) => {
        this.memberFormGroup.patchValue({
          image: res['data']['image']
        });
      });
  }

  onCountryChanged(event: any): void {
    this.countryCodeObject = event;
  }

  patchValues(): any {
    let value: any = {
      phoneNo: '',
      dialCode: ''
    };

    const patchValueToCountryCode = (): void => {
      let tempCountryCode =
        this.memberFormGroup['controls']['phoneNo']['value'];

      if (tempCountryCode) {
        tempCountryCode = tempCountryCode.split('');
        tempCountryCode.shift();
        tempCountryCode = tempCountryCode.join('');
      }

      if (tempCountryCode !== this.countryCodeObject['dialCode']) {
        this.memberFormGroup.patchValue({
          dialCode: `+${this.countryCodeObject['dialCode']}`
        });
      }
    };

    const patchValueToPhoneField = (): void => {
      let phone = this.memberFormGroup['controls']['phoneNo']['value'];

      if (
        phone &&
        phone.includes(this.memberFormGroup['controls']['dialCode']['value'])
      ) {
        phone = phone.split(
          this.memberFormGroup['controls']['dialCode']['value']
        );
        if (value?.phoneNo !== undefined) {
          value['phoneNo'] = phone[1].trim();
        }
      }
    };
    patchValueToCountryCode();
    value = this.memberFormGroup['value'];
    patchValueToPhoneField();

    return value;
  }

  onSubmit(): void {
    this.submitted = true;
    this.trimFormFields();
    const modifiedValues = this.patchValues();

    if (modifiedValues.pinCode === '') {
      delete (modifiedValues.pinCode);
    }

    if (modifiedValues.image === '') {
      delete modifiedValues.image;
    }
    if (modifiedValues.companyWebsite === '') {
      delete modifiedValues.companyWebsite;
    }
    if (this.memberFormGroup.valid) {
      this.MatDialogRef.close(modifiedValues);
    }
    if (modifiedValues.latitude === '') {
      delete modifiedValues.latitude;
    }
    if (modifiedValues.longitude === '') {
      delete modifiedValues.longitude;
    }
    
  }

  // trimFormFields(): void {
  //   this.memberFormGroup.patchValue({
  //     businessName: this.memberFormGroup.get('businessName')?.value.trim(),
  //     name: this.memberFormGroup.get('name')?.value.trim(),
  //     address: this.memberFormGroup.get('address')?.value.trim(),
  //     city: this.memberFormGroup.get('city')?.value.trim(),
  //     pinCode: this.memberFormGroup.get('pinCode')?.value.trim(),
  //     email: this.memberFormGroup.get('email')?.value.trim(),
  //     companyWebsite: this.memberFormGroup.get('companyWebsite')?.value.trim(),
  //     typeOfBusiness: this.memberFormGroup.get('typeOfBusiness')?.value.trim()
  //   });
  // }
  trimFormFields(): void {
    this.memberFormGroup.patchValue({
      businessName: typeof this.memberFormGroup.get('businessName')?.value === 'string'
        ? this.memberFormGroup.get('businessName')?.value.trim()
        : this.memberFormGroup.get('businessName')?.value,
  
      name: typeof this.memberFormGroup.get('name')?.value === 'string'
        ? this.memberFormGroup.get('name')?.value.trim()
        : this.memberFormGroup.get('name')?.value,
  
      address: typeof this.memberFormGroup.get('address')?.value === 'string'
        ? this.memberFormGroup.get('address')?.value.trim()
        : this.memberFormGroup.get('address')?.value,
  
      city: typeof this.memberFormGroup.get('city')?.value === 'string'
        ? this.memberFormGroup.get('city')?.value.trim()
        : this.memberFormGroup.get('city')?.value,
  
        pinCode: this.memberFormGroup.get('pinCode')?.value != null
        ? String(this.memberFormGroup.get('pinCode')?.value).trim()
        : '',
      
  
      email: typeof this.memberFormGroup.get('email')?.value === 'string'
        ? this.memberFormGroup.get('email')?.value.trim()
        : this.memberFormGroup.get('email')?.value,
  
      companyWebsite: typeof this.memberFormGroup.get('companyWebsite')?.value === 'string'
        ? this.memberFormGroup.get('companyWebsite')?.value.trim()
        : this.memberFormGroup.get('companyWebsite')?.value,
  
      typeOfBusiness: typeof this.memberFormGroup.get('typeOfBusiness')?.value === 'string'
        ? this.memberFormGroup.get('typeOfBusiness')?.value.trim()
        : this.memberFormGroup.get('typeOfBusiness')?.value,
        latitude: this.memberFormGroup.get('latitude')?.value != null
  ? String(this.memberFormGroup.get('latitude')?.value).trim()
  : '',

longitude: this.memberFormGroup.get('longitude')?.value != null
  ? String(this.memberFormGroup.get('longitude')?.value).trim()
  : '',

    });
  }
  

  // protected addressChange(place: any): void {
  //   this._googlePlaces.initAutocomplete(place);
  //   this._googlePlaces
  //     .getPlaceObservable()
  //     .pipe(take(1))
  //     .subscribe({
  //       next: location => {
  //         const addressDetails = addressChange(location);
  //         this.memberFormGroup.patchValue({
  //           address: addressDetails.address,
  //           city: addressDetails.city,
  //           state: addressDetails.state,
  //           pinCode: addressDetails.pinCode,
  //           latitude: addressDetails.lat,
  //           longitude: addressDetails.lng
  //         });
  //       }
  //     });
  // }
}
